export default {
    props: {
        message: {
            type: String,
            require: true
        },
    },
    template: `
    <div class="notification">
        <h2>{{ message }}</h2>
    </div>
    `
}